import { combineReducers } from 'redux';
import permisionsReducer from './permisions/reducer';
import authReducer from './reducers/auth';
import filterReducer from './reducers/filter';
import mapReducer from './reducers/map';
import reportsReducer from './reducers/reports';
import updaterReducer from './reducers/updater';

export const rootReducer = combineReducers({
  map: mapReducer,
  auth: authReducer,
  reports: reportsReducer,
  filter: filterReducer,
  updater: updaterReducer,
  permissions: permisionsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
